import type { RouteRecordRaw } from 'vue-router'

import Board from '@/modules/Board.vue'
import Login from '@/modules/onboarding/Login.vue'
import RedirectLogin from '@/modules/onboarding/RedirectLogin.vue'
import SupportLogin from '@/modules/onboarding/SupportLogin.vue'

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: 'board' }
  },
  {
    name: 'login',
    path: '/login',
    component: Login
  },
  {
    name: 'redirectLogin',
    path: '/redirect-login',
    component: RedirectLogin
  },
  {
    name: 'supportLogin',
    path: '/support-login',
    component: SupportLogin
  },
  {
    name: 'board',
    path: '/board',
    component: Board
  }
]
